import axios from "axios";
import paramsBuilder from "./params-builder";
import store from "@/store";
import router from "@/router";

const getAxiosInstance = () => {
  const axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    headers: {
      "Content-type": "application/json",
    },
  });

  // Add interceptors for request
  axiosInstance.interceptors.request.use(
    function (config) {
      // add queryparams to headers reqeust
      if (store.state.queryParams)
        Object.keys(store.state.queryParams).forEach((key) => {
          config.headers[key] = store.state.queryParams[key];
        });

      // if (!navigator.onLine) {
      //     console.log("عدم اتصال به اینترنت!");
      //     return;
      //   }

      //   let jwtToken = storeUtilities.getToken();
      //   if (jwtToken) config.headers.Authorization = "Bearer " + jwtToken;

      return config;
    },
    function (error) {
      // Do something with request error
      return Promise.reject(error);
    }
  );

  // Add interceptors for response
  axiosInstance.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      if (error.response) {
        let errorMessage = error.response.data?.message;
        if (Array.isArray(errorMessage)) errorMessage = errorMessage.join("\n");
        console.log("intercep", error.response.status);
        switch (error.response.status) {
          case 401:
          case 403:
            store.commit("showSnackbar", {
              message: errorMessage ?? "دسترسی غیر مجاز",
            });
            router.push({ name: "Forbidden" });
            break;

          case 500:
            store.commit("showSnackbar", "خطای داخلی سرور");
            break;

          default:
            store.commit("showSnackbar", {
              message: errorMessage ?? "خطا در دریافت اطلاعات",
            });
        }
      } else if (error.request) {
        // The request was made but no response was received
        store.commit("showSnackbar", {
          message: "خطایی رخ داده است. ارتباط اینترنت خود را بررسی کنید.",
        });
      } else {
        // Something happened in setting up the request that triggered an Error
        store.commit("showSnackbar", {
          message:
            "خطایی در پردازش اطلاعات رخ داده است. لطفا بعدا امتحان کنید.",
        });
      }

      const result = Promise.reject(error);
      if (!error.response) return result;
    }
  );

  return axiosInstance;
};

const getCancelToken = (cancelTokenSource) =>
  cancelTokenSource ? cancelTokenSource.token : null;
// clone instance and add new config to instance
const getInstance = (newAxiosConfig) => {
  let instance = getAxiosInstance();
  Object.keys(newAxiosConfig).forEach(
    (property) => (instance.defaults[property] = newAxiosConfig[property])
  );

  return instance;
};

const http = {
  get: (url, cancelTokenSource = null, axiosConfig = {}) => {
    let instance = getInstance(axiosConfig);

    return instance.get(url, {
      cancelToken: getCancelToken(cancelTokenSource),
    });
  },

  getByParams: (url, params, cancelTokenSource = null, axiosConfig = {}) => {
    let instance = getInstance(axiosConfig);
    // instance.defaults.headers['Content-type'] = 'application/x-www-form-urlencoded';

    let readyParams = {};
    if (params) {
      // to remove empty params
      const paramsWithoutEmpty = {};
      Object.keys(params).forEach((key) => {
        if (
          params[key] !== null &&
          params[key] !== "" &&
          params[key] !== undefined
        )
          paramsWithoutEmpty[key] = params[key];
      });

      // readyParams = decodeURIComponent(paramsBuilder(paramsWithoutEmpty)).replace(/\[\]/g, "");
      readyParams = decodeURIComponent(paramsBuilder(paramsWithoutEmpty));
    }
    // Note: correct querystring => ?id=1&myArray[]=1&myArray[]=2
    // but aspcore can't handle this , then querystring change to above line(remove [])

    return instance.get(url + "?" + readyParams, {
      cancelToken: getCancelToken(cancelTokenSource),
    });
    // return instance.get(url, { params: params, cancelToken: getCancelToken(cancelTokenSource) }); //  it makes params too.they are the same
  },

  postByParams: (
    url,
    params = null,
    cancelTokenSource = null,
    axiosConfig = {}
  ) => {
    let instance = getInstance(axiosConfig);

    let readyParams = {};
    if (params) readyParams = paramsBuilder(params);

    return instance.post(url, readyParams, {
      cancelToken: getCancelToken(cancelTokenSource),
    });
  },

  post: (url, model, cancelTokenSource = null, axiosConfig = {}) => {
    let instance = getInstance(axiosConfig);

    return instance.post(url, model, {
      cancelToken: getCancelToken(cancelTokenSource),
    });
  },

  postByFormData: (
    url,
    formData,
    cancelTokenSource = null,
    axiosConfig = {}
  ) => {
    let instance = getInstance(axiosConfig);

    return instance.post(url, formData, {
      headers: { "Content-type": "multipart/form-data" },
      cancelToken: getCancelToken(cancelTokenSource),
    });
  },

  put: (url, model, cancelTokenSource = null, axiosConfig = {}) => {
    let instance = getInstance(axiosConfig);

    return instance.put(url, model, {
      cancelToken: getCancelToken(cancelTokenSource),
    });
  },

  delete: (url, cancelTokenSource = null, axiosConfig = {}) => {
    let instance = getInstance(axiosConfig);

    return instance.delete(url, {
      cancelToken: getCancelToken(cancelTokenSource),
    });
  },

  patch: (url, model, cancelTokenSource = null, axiosConfig = {}) => {
    let instance = getInstance(axiosConfig);

    return instance.patch(url, model, {
      cancelToken: getCancelToken(cancelTokenSource),
    });
  },
};

export { http };
